module.exports = __webpack_public_path__ + "img/10.5e7a7420.png";